import { EProcessNames } from "api/enums";
import AttachmentsMeasurement from "components/Attachments/AttachmentsMeasurement";
import SendToBilling from "components/Billing/SendToBilling";
import ShowBillingData from "components/Billing/ShowBillingData";
import MeasurementsTable from "components/Measurement/MeasurementsTable";
import { lang } from "i18nLang";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  AccessProfileStore,
  ContractStore,
  MeasurementListStore,
  MeasurementStore,
  MessageStore,
} from "store";

const MeasurementTab = observer(() => {
  const history = useHistory();
  const [openEditBilling, setOpenEditBilling] = useState(false);
  const [openShowBilling, setOpenShowBilling] = useState(false);
  const [openAttachment, setOpenAttachment] = useState(false);
  const [selectedMeasurementUid, setSelectedMeasurementUid] = useState("");

  const handleClickEditMeasurement = (uid) => {
    history.push(
      `/${ContractStore.getCurrentContract()?.uid}/measurement/${uid}`
    );
  };

  const handleClickBillingMeasurement = (uid) => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.CRIAR_DOC_VENDA
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    setSelectedMeasurementUid(uid);
    setOpenEditBilling(true);
  };

  const handleClickCloseEditBilling = () => {
    setOpenEditBilling(false);
    setSelectedMeasurementUid("");
  };

  const handleClickShowBilling = (uid) => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.CRIAR_DOC_VENDA
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    setSelectedMeasurementUid(uid);
    setOpenShowBilling(true);
  };

  const handleClickCloseShowBilling = () => {
    setOpenShowBilling(false);
    setSelectedMeasurementUid("");
  };

  const handleClickAttachment = (uid) => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.ANEXAR_ARQUIVOS
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    setSelectedMeasurementUid(uid);
    setOpenAttachment(true);
  };

  const handleClickCloseAttachment = () => {
    setOpenAttachment(false);
    setSelectedMeasurementUid("");
  };

  const handleChangeStatusMeasurement = (uid, newStatus) => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.APROVAR_MEDICOES
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }

    const measurement = MeasurementListStore.findMeasurement(uid);
    if (measurement)
      MeasurementStore.updateMeasurementStatus(measurement, newStatus);
  };

  const handleChangeDatesMeasurement = (uid, initialDate, finalDate) => {
    const measurement = MeasurementListStore.findMeasurement(uid);
    if (measurement)
      MeasurementStore.updateMeasurementPeriod(
        measurement,
        initialDate,
        finalDate
      );
  };

  const handleExpandDetails = async (uid) => {
    const measurement = MeasurementListStore.findMeasurement(uid);
    if (measurement) {
      await MeasurementStore.updateBillingStatus(measurement);
      MeasurementStore.updateBillingInvoices(measurement);
      MeasurementStore.updateBillingOrderIssueDate(measurement);
    }
  };

  return (
    <>
      <MeasurementsTable
        rows={MeasurementListStore.rows}
        onEdit={handleClickEditMeasurement}
        onSendToBilling={handleClickBillingMeasurement}
        onShowBilling={handleClickShowBilling}
        onAttachFiles={handleClickAttachment}
        onChangeStatus={handleChangeStatusMeasurement}
        onChangeDates={handleChangeDatesMeasurement}
        onExpandDetails={handleExpandDetails}
      />
      {selectedMeasurementUid && (
        <SendToBilling
          open={openEditBilling}
          onClose={handleClickCloseEditBilling}
          measurementId={selectedMeasurementUid}
        />
      )}
      {selectedMeasurementUid && (
        <ShowBillingData
          open={openShowBilling}
          onClose={handleClickCloseShowBilling}
          measurementId={selectedMeasurementUid}
        />
      )}
      {selectedMeasurementUid && (
        <AttachmentsMeasurement
          open={openAttachment}
          onClose={handleClickCloseAttachment}
          measurementId={selectedMeasurementUid}
        />
      )}
    </>
  );
});

export default MeasurementTab;
